import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export default function HowToButton() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<HelpOutlineIcon />}
        onClick={handleOpen}
        sx={{
          mb: 2,
          backgroundColor: 'transparent',
          boxShadow: 'none',
          fontWeight: 700,
          fontSize: '1.1rem',
          textTransform: 'uppercase',
          borderColor: '#0072CE',
          color: '#fff',
          '&:hover': {
            backgroundColor: 'rgba(0,114,206,0.08)',
            borderColor: '#0072CE',
            color: '#fff',
          },
        }}
      >
        Instructions
      </Button>
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle sx={{ fontSize: '2rem', fontWeight: 'bold' }}>How to start analyzing your laps</DialogTitle>
        <DialogContent>
          <Typography gutterBottom sx={{ mb: 3 }}>
            <strong>1. Download the Agent</strong><br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Go to <b>Downloads Agent</b> and install the GT7 telemetry agent on your system.<br />
          </Typography>
          <Typography gutterBottom sx={{ mb: 3 }}>
            <strong>2. Launch the Agent</strong><br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Start the agent.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- If you are on Windows, a pop-up will appear asking for permission to change your Firewall settings.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Click <b>Allow</b> so the agent can receive data from the game over your local network (You need Administrator rights for this step).<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Enter your PlayStation's IP address.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Choose to save laps locally or directly to your GT Telemetry Session.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- If saving locally, laps are stored in the <b>laps</b> folder and must be uploaded manually.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- For direct upload, copy and paste the JWT token from the <b>Active Session</b> box (top right).<br />
          </Typography>
          <Typography gutterBottom sx={{ mb: 3 }}>
            <strong>3. Record Your Laps</strong><br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Play Gran Turismo 7 to record laps.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Laps are detected automatically when a full lap is completed.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Pausing the game does not affect lap recording.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- You can also record laps from a replay.<br />
          </Typography>
          <Typography gutterBottom sx={{ mb: 3 }}>
            <strong>4. Select & Upload Laps</strong><br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Click <b>Select Lap</b> to choose laps for analysis.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Click <b>Upload</b> to add laps from your computer.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Select multiple laps for comparison.<br />
          </Typography>
          <Typography gutterBottom sx={{ mb: 3 }}>
            <strong>5. Visualize & Compare</strong><br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Use the dashboard to view lap traces and input graphs.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Set a custom track range or use pre-set corner sections.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Replay laps at different speeds.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Highlight throttle/brake inputs on the lap trace.<br />
          </Typography>
          <Typography gutterBottom sx={{ mb: 3 }}>
            <strong>6. Compare Laps</strong><br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Select two laps and click <b>Compare Laps</b> for a detailed analysis.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Review the table to see where time was lost and how to improve.<br />
          </Typography>
          <Typography gutterBottom sx={{ mb: 3 }}>
            <strong>7. Download Laps</strong><br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Click <b>Download</b> to save laps from your session.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Use <b>Auto Download</b> to automatically download laps before your session expires.<br />
          </Typography>
          <Typography gutterBottom sx={{ mb: 3 }}>
            <strong>8. Delete Laps</strong><br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Click <b>Delete Laps</b> to remove unwanted laps.<br />
            &nbsp;&nbsp;&nbsp;&nbsp;- Deleting laps frees up storage for new ones, as storage capacity is limited.<br />
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
